export const applyTrackingId = (trackingId?: string) =>
  trackingId ? { 'data-link-id': trackingId } : {};
